import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const TitleIcon = ({ fontWeight, icon, title, variant }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            '& svg path': {
                fill: (theme) => theme.palette.primary.main,
            },
        }}
    >
        {icon}
        <Typography variant={variant} fontWeight={fontWeight}>
            {title}
        </Typography>
    </Box>
);

TitleIcon.defaultProps = { variant: 'h4' };

TitleIcon.propTypes = {
    fontWeight: PropTypes.string,
    icon: PropTypes.object,
    title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    variant: PropTypes.string,
};

export default TitleIcon;
